<article class="short-article-widget">
  <div class="short-article--image">
    <app-webp-image
      [src]="getImageUrl()"
      [alt]="widget.data.title"
      [blurhash]="widget.data.blurHash || null">
    </app-webp-image>
  </div>
  <div class="short-article--content">
    <h4>{{widget.data.title}}</h4>
    <div [innerHtml]="widget.data.text|safe"></div>
  </div>
</article>
